import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=37a1060c&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=ts"
export * from "./UserDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=37a1060c&prod&lang=scss&scoped=true"
import style1 from "./UserDialog.vue?vue&type=style&index=1&id=37a1060c&prod&lang=scss"
import style2 from "./UserDialog.vue?vue&type=style&index=2&id=37a1060c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a1060c",
  null
  
)

export default component.exports